
import { Component, Vue, Prop, Ref } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class extends Vue {
  @Prop() id: string
  @Prop() size: any
  @Prop({ default: false }) def: boolean
  @Prop({ default: false }) crossOrigin: boolean
  @Prop({ default: false }) clearCache: boolean

  @Ref()
  avatar: HTMLElement

  get imgUrl() {
    const url = new URL(this.$store.$global.fileTarget + this.stringToHex(this.id) + '.jpg')

    if (this.$store.$global.upUpdateTime && this.$store.$storeUser.isLogin() && this.id == this.$store.$storeUser.UserInfo.id) {
      url.searchParams.set('avatar', `${this.$store.$global.upUpdateTime}`)
    }

    if (this.clearCache === true) {
      url.searchParams.set('t', `${Date.now()}`)
    }

    return url.toString()
  }

  mounted() { }
}
